export default __webpack_public_path__ + "static/media/prev-C1A-1.abcf37b1.png";